module.exports = __webpack_public_path__ + "img/10-11-1.587a7687.jpg";